const DisplayVideo = ({videoFound, displayData}) => {
    const handleVideoError = () =>{
        
    }

    return (
        <div className="filmroom_video_frame">
          {videoFound ? (
            <video
              width="100%"
              height="100%"
              src={displayData.video1.src + displayData.video1.video_object_key}
              title="YouTube video player"
              preload="auto"
              controls
              autoPlay
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              onError={handleVideoError}
            ></video>
          ) : (
            <span>未選擇影片/影片播放錯誤/影片不存在</span>
          )}
        </div>
    )
}

export default DisplayVideo;